<template>
  <div class="fixed z-50 inset-0 overflow-y-auto" id="upload-evidence">
    <div class="flex items-end justify-center min-h-screen pt-4 px-4 pb-20 text-center sm:block sm:p-0">
      <div class="fixed inset-0 transition-opacity" aria-hidden="true">
        <div class="absolute inset-0 bg-gray-800 opacity-75"></div>
      </div>

      <!-- This element is to trick the browser into centering the modal contents. -->
      <span class="hidden sm:inline-block sm:align-middle sm:h-screen" aria-hidden="true">&#8203;</span>

      <div class="inline-block align-bottom bg-white rounded-lg px-4 pt-5 pb-4 text-left overflow-hidden shadow-xl transform transition-all sm:my-8 sm:align-middle sm:max-w-md sm:w-full sm:p-6" role="dialog" aria-modal="true" aria-labelledby="modal-headline">
        <div>
          <p class="font-bold text-gray-700 text-lg text-center"> Edit Phone </p>
        </div>
        <div class="mt-1">
          <div class="flex">
            <div class="flex rounded-md shadow-sm w-full relative">
              <input type="text" name="phone" v-model="phone" placeholder="Enter phone" autofocus class="focus:ring-indigo-500 focus:border-indigo-500 flex-1 block w-full rounded-none rounded-l sm:text-lg text-gray-800 font-medium placeholder-gray-400 border-gray-300 pr-10">
            </div>
          </div>

          <div v-if="error" class="mt-1">
            <p class="text-sm font-medium text-red-500">{{error}}</p>
          </div>
        </div>


        <div class="justify-end mt-5 flex sm:mt-4 ">
          <button type="button" @click="updatePhone()" class="inline-flex w-full justify-center rounded-md bg-indigo-600 px-3 py-2 text-sm font-semibold text-white shadow-sm hover:bg-indigo-500 sm:w-auto">Done</button>
          <button type="button" @click="closeModal()" class="mt-3 inline-flex w-full justify-center rounded-md bg-white px-3 py-2 text-sm font-semibold text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 hover:bg-gray-50 sm:ml-3 sm:mt-0 sm:w-auto">Cancel</button>
        </div>

      </div>
    </div>
  </div>
</template>
<script>
import UserApi from "@/services/api/User";
export default {
  props: ["user"],

  data() {
    return {
      phone: "",
      error: "",
    };
  },

  created() {
    this.phone = this.user.phone;
  },

  methods: {
    updatePhone() {
      window.blockUI();

      UserApi.updatePhone(this.phone)
        .then((res) => {
          window.unblockUI();
          if (res.data.error) {
            this.error = res.data.message;
            return;
          }
          this.phone = res.data.phone;
          this.closeModal();
        })
        .finally(() => {
          window.unblockUI();
        });
    },

    closeModal() {
      this.$emit('close-edit-phone-modal', this.phone);
    }
  },
};
</script>
